module.exports = __webpack_public_path__ + "static/media/JH.2f64a977.svg";